'use client'

import { useEffect } from 'react'
import { useSearchParams, useRouter } from 'next/navigation'

export default function OAuthCallbackHandler() {
  const searchParams = useSearchParams()
  const router = useRouter()

  useEffect(() => {
    const code = searchParams.get('code')
    
    if (code) {
      // Redirect to auth callback handler
      const redirectUrl = `/auth/callback?code=${code}`
      router.push(redirectUrl)
    }
  }, [searchParams, router])

  return null
}

